import React from 'react';
import { AlertTriangle, RotateCcw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/dashboard';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white flex items-center justify-center px-6">
          <div className="text-center max-w-sm">
            <div className="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-5">
              <AlertTriangle className="w-7 h-7 text-amber-500" strokeWidth={1.5} />
            </div>
            <h1 className="text-[18px] font-bold text-slate-900 mb-2">
              {this.props.title || 'Oops! Something went wrong'}
            </h1>
            <p className="text-[13px] text-slate-400 mb-8 leading-relaxed">
              {this.props.message || 'An unexpected error occurred. Please try again.'}
            </p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={this.handleRetry}
                className="h-10 px-5 text-[13px] font-semibold bg-slate-900 text-white rounded-full hover:bg-slate-800 transition-colors flex items-center gap-2"
              >
                <RotateCcw className="w-3.5 h-3.5" /> {this.props.retryLabel || 'Retry'}
              </button>
              <button
                onClick={this.handleGoHome}
                className="h-10 px-5 text-[13px] font-semibold bg-slate-100 text-slate-600 rounded-full hover:bg-slate-200 transition-colors flex items-center gap-2"
              >
                <Home className="w-3.5 h-3.5" /> {this.props.homeLabel || 'Go to Home'}
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
